import React from "react"
import { css, cx } from "emotion"

const base = css`
  padding: 1rem;
  margin: 0 auto;
  width: 100%;
  height: 100%;
  min-height: 320px;
  display: flex;
  flex: 1;

  position: relative;
`

function MainContainer(props) {
  const { children, className } = props
  const cn = cx(base, className)
  return (
    <div id="main-container" className={cn}>
      {children}
    </div>
  )
}

export default MainContainer
